
import { authorize_onboarding } from "../helper/authorize-token";
import superagent from 'superagent';

const CHAT_LOAD = "CHAT_LOAD";
const CHAT_CLEAR = "CHAT_CLEAR";

const LoadChats = (continuations) => {

  return (dispatch, getState) => {
    dispatch({
      type: CHAT_LOAD,
      payload: superagent
        .post("/api/chat/load-chats")
        .send({ continuations })
        .use(authorize_onboarding(
          getState().user.token, getState().user.onboarding_token))
    })
  }
}

const ClearChats = () => {
  return dispatch => {
    dispatch({
      type: CHAT_CLEAR,
    })
  }
}


const chatReducer = (state = {}, action) => {

  switch (action.type) {
    case CHAT_LOAD + "_FULFILLED":
      return action.payload.body.data;
    case CHAT_CLEAR:
      return {};
    default:
      return state;
  }
}

export { chatReducer, LoadChats, ClearChats };
